module.exports = __webpack_public_path__ + "assets/img/27_1240.6da7119d.jpg";